import React, { createContext, RefObject } from 'react';

type InputInfo = {
  ref: RefObject<HTMLInputElement | HTMLTextAreaElement>;
  hasError: boolean;
};

type FormContextType = {
  registerInput: (
    name: string,
    ref: RefObject<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement> 
  ) => void;
  setInputError: (name: string, hasError: boolean) => void;
  getInputs: () => Record<string, InputInfo>;
  registerValidation: (name: string, validateFn: () => boolean) => void;
  runAllValidations: () => boolean;
};

export const FormContext = createContext<FormContextType>({
  registerInput: () => {},
  setInputError: () => {},
  getInputs: () => ({}),
  registerValidation: () => {},
  runAllValidations: () => true,
});
